export const hotelIDTypes = {
    set: "[HotelID] set",
    default: "[HotelID] default",
    clean: "[HotelID] clean",
};
